export default "__VITE_ASSET__BNYCScYQ__"